__turbopack_context__.v({
  "img": "jEPPmq_img",
  "imgGrid": "jEPPmq_imgGrid",
  "root": "jEPPmq_root",
  "section": "jEPPmq_section",
  "small": "jEPPmq_small",
  "text": "jEPPmq_text",
  "title": "jEPPmq_title",
});
